import FormX from 'sb-formx'
import { required, streetAddress, maxLength, zipCode, userNameValidation,
  cardNumber, expDate, cardCVV, telephone, email, uniqueEmail } from 'helpers/validation'
import { getCookieValue } from 'helpers'


const isDebug = Boolean(getCookieValue('debug', true))


const registerForm = new FormX({
  fields: {
    email: {
      validate: [ required, email, uniqueEmail({ errorWithLink: true }) ],
      hasAsyncValidators: true,
      validateAfterChange: false,
    },
    password: [ required ],
    gender: [ required ],
    firstName: [ required, userNameValidation, maxLength(100) ],
    lastName: [ required, userNameValidation, maxLength(100) ],
    receiveUpdates: {
      validate: [],
      value: true,
    },
  },
})

const userInfoForm = new FormX({
  fields: {
    firstName: [ required, userNameValidation, maxLength(100) ],
    lastName: [ required, userNameValidation, maxLength(100) ],
  },
})

const shippingForm = new FormX({
  fields: {
    street: [ required, streetAddress ],
    apt: [],
    zipCode: [ required, zipCode ],
    city: [ required ],
    state: [ required ],
    country: {
      validate: [ required ],
      value: 'United States',
      readOnly: true, // TODO add "readOnly" support to FormX
    },
    telephone: [ telephone ],
    setBillingZip: [],
  },
  initialValues: {
    setBillingZip: true,
  },
})

const creditCardForm = new FormX({
  fields: {
    cardNumber: [ required, cardNumber ],
    holderName: [ required ],
    expDate: [ required, expDate ],
    cvc: [ required, cardCVV ],
    zipCode: [ required, zipCode ],
  },
  initialValues: !isDebug ? {} : {
    cardNumber: '4242424242424242',
    holderName: 'John Doe',
    expDate: '11/22',
    cvc: '088',
    zipCode: '10095',
  },
})

const couponForm = new FormX({
  fields: {
    code: [],
  },
})


export {
  userInfoForm,
  registerForm,
  shippingForm,
  creditCardForm,
  couponForm,
}
